module.exports = function getFunctionName(f) {
  return f.displayName || f.name || '<function' + f.length + '>';
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/getFunctionName.js
// module id = 43
// module chunks = 0